export const COLORS = [0, 1, 2, 3];
export const COLOR_NAMES = ["red", "blue", "green", "yellow"];
export const YARD = -1;
export const RING = 52;
export const BRANCH_LEN = 5;
export const TOKENS_PER_PLAYER = 4;
export const ENTRY = { 0: 0, 1: 39, 2: 26, 3: 13 };
export const STARS = [8, 21, 34, 47];
export const SAFE = new Set([...STARS, ...Object.values(ENTRY)]);
export const branchCell = (color, index) => 100 + color * 10 + index;
export const homeCell = (color) => 999 + color;
export const isBranch = (cell) => cell >= 100 && cell < 200;
export const isBranchForColor = (cell, color) => cell >= branchCell(color, 0) && cell < branchCell(color, BRANCH_LEN);
export const isHome = (cell) => cell >= 999 && cell <= 1002;
export class IllegalActionError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.code = code;
    }
}
export function turnState(state) {
    if (state.phase === "over")
        return "Victory";
    return state.phase === "move" ? "ChoosingMove" : "WaitingForRoll";
}
